import React, { useState, useEffect, useRef } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { fetchdata } from '../reduxactions/donorrsactions/DOrgPrintTranscriptActions';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import 'jspdf-autotable';
import { Panel } from 'primereact/panel';


const DOrgPrintTranscript = () => {
  const uid = window.sessionStorage.getItem('uid');
  const dispatch = useDispatch();

  const location = useLocation();
  const [queryParams, setQueryParams] = useState(null);

  // ✅ ADD
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("Id") as any);
  }, [location]);

  const { fundid } = useParams();
  const { rid } = useParams();

  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid, fundid, rid) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }

  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch])

  const data = useSelector((state: RootState) => state.dorgprint.data)
  const [globalFilter, setGlobalFilter] = useState('');

  const print = () => {
    const content = printRef.current;
    if (!content) return;

    const printWindow = window.open('', '', 'width=1000,height=700');
    if (!printWindow) return;

    printWindow.document.write(`
    <html>
      <head>
        <title>Organization Transcript</title>
      </head>
      <body>
        ${content.innerHTML}
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };


  const exportToCSV = () => {
    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = 'transcript_data.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToExcel = () => {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const blob = new Blob(
      [XLSX.write(wb, { bookType: 'xlsx', type: 'array' })],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
    );

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'data.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/vieworganization-reports.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };


  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">

            {/* <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-9">
                    <h1>Organization Transcript</h1>
                  </div>
                    <div className="col-3">
                      <a
                        title="help"
                        onClick={(e) => openWindow(e, IUrl)}
                        style={{

                          color: "blue",
                          fontSize: 15, cursor: "pointer"
                        }}
                      >Help for this Page &nbsp;
                        <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                      </a>
                    </div>
                </div>
              </div>
            </section> */}
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Organization Transcript</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>

            {/* <section className="content"> */}
            <Panel>
              <div className="grid">
                <div className="col-12">

                  <div className="grid">
                    <div className="col-2">
                      <Button label="CSV" icon="pi pi-file" onClick={exportToCSV} />
                    </div>
                    <div className="col-2">
                      <Button label="Excel" severity="success" onClick={exportToExcel} />
                    </div>
                    <div className="col-2">
                      <Button label="Print" severity="warning" icon="pi pi-print" onClick={print} />
                    </div>
                    <div className="col-2">
                      <Button label="Pdf" severity="info" onClick={print} />
                    </div>
                  </div>

                  <div className="card flex flex-wrap justify-content-end my-2">
                    <span className="p-input-icon-left">
                      <i className="pi pi-search ml-2" />

                      <InputText
                        className="app-search-input"
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Global Search"
                      />
                    </span>
                  </div>
                  <div ref={printRef}>
                    <DataTable
                      value={data}
                      stripedRows
                      paginator
                      rows={5}
                      globalFilter={globalFilter}
                      tableStyle={{ minWidth: '50rem' }}
                    >
                      <Column body={(_, { rowIndex }) => rowIndex + 1} header="S.No" />
                      <Column field="firstname" header="Donor Name" />
                      <Column field="CountryName" header="Country" />
                      <Column field="send_date" header="Paid Date" />
                      <Column field="Amount" header="Amount" />
                    </DataTable>

                    {/* ✅ PLAIN TABLE FOR PRINT (NO CSS)
  <table border={1} width="100%" cellPadding={5} cellSpacing={0}>
    <thead>
      <tr>
        <th>S.No</th>
        <th>Donor Name</th>
        <th>Country</th>
        <th>Paid Date</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      {data && data.map((row: any, index: number) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{row.firstname}</td>
          <td>{row.CountryName}</td>
          <td>{row.send_date}</td>
          <td>{row.Amount}</td>
        </tr>
      ))}
    </tbody>
  </table> */}
                  </div>


                </div>
              </div>
            </Panel>
            {/* </section> */}

          </div>
        </div>
      </div>
    </div>
  );
}

export default DOrgPrintTranscript;
